var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{class:['v-view-primary', _vm.$store.getters.getIsClientData === false
  ? 'v-view-primary-upgrade' : '']},[_c('OrganismTheHeader'),(_vm.$route.name === 'map')?_c('section',[_c('OrganismEditionSectionChart')],1):_c('section',{key:"editionSection",staticClass:"v-edition-section"},[_c('OrganismEditionSectionNavigation'),_c('OrganismEditionSectionContent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }